module.exports = __webpack_public_path__ + "img/groceries.a0efe9ec.webp";